import React from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import HomePage from "./pages/HomePage";
import ReservationPage from "./pages/ReservationPage";
import BlogListPage from "./pages/BlogListPage";
import BlogDetailPage from "./pages/BlogDetailPage";
import MenuListPage from "./pages/MenuListPage";
import MenuDetailPage from "./pages/MenuDetailPage";
import FranchisePage from "./pages/FranchisePage";
import OutletsPage from "./pages/OutletsPage";
import ContactPage from "./pages/ContactPage";
import AboutPage from "./pages/AboutPage";
import OutletGalleryPage from "./pages/OutletGalleryPage";
import FunActivitiesPage from "./pages/FunActivitiesPage";
import AwardsPage from "./pages/AwardsPage";
import CateringPage from "./pages/CateringPage";
import ExpressPage from "./pages/ExpressPage";
import EventsPage from "./pages/EventsPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import TermsAndConditionsPage from "./pages/TermsAndConditionsPage";
import BestRestaurantInSalemPage from "./pages/BestRestaurantInSalemPage";
import BestRestaurantInErodePage from "./pages/BestRestaurantInErodePage";
import BestRestaurantInCoimbatorePage from "./pages/BestRestaurantInCoimbatorePage";
import BestRestaurantInKrishnagiriPage from "./pages/BestRestaurantInKrishnagiriPage";
import BestRestaurantInPudukkottaiPage from "./pages/BestRestaurantInPudukkottaiPage";
import BestBbqRestaurantInPudukkottaiPage from "./pages/BestBbqRestaurantInPudukkottaiPage";
import EventRegisterPage from "./pages/EventRegisterPage";
import AdminRouter from "./pages/admin/AdminRouter";

const AppRoutes = () => {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith("/admin");

  if (isAdminRoute) {
    return (
      <Routes>
        <Route path="/admin/*" element={<AdminRouter />} />
      </Routes>
    );
  }

  return (
    <>
      <Header />
      <main>
        <Routes>
          {/* Main Canonical Routes (Lowercase Kebab-Case) */}
          <Route path="/" element={<HomePage />} />
          <Route path="/about-us" element={<AboutPage />} />
          <Route path="/contact-us" element={<ContactPage />} />
          <Route path="/menu" element={<MenuListPage />} />
          <Route path="/menu-details" element={<MenuDetailPage />} />
          <Route path="/outdoor-catering" element={<CateringPage />} />
          <Route path="/barbequeen-express" element={<ExpressPage />} />
          <Route path="/events" element={<EventsPage />} />
          <Route path="/outlet-gallery" element={<OutletGalleryPage />} />
          <Route path="/fun-activities" element={<FunActivitiesPage />} />
          <Route path="/awards-achievements" element={<AwardsPage />} />
          <Route path="/outlets" element={<OutletsPage />} />
          <Route path="/franchise" element={<FranchisePage />} />
          <Route path="/career" element={<ReservationPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="/terms-and-conditions" element={<TermsAndConditionsPage />} />
          <Route path="/reservation" element={<ReservationPage />} />
          <Route path="/varnangal-aayiram2.o" element={<ReservationPage />} />
          <Route path="/varnangal-aayiram2-0" element={<ReservationPage />} />

          {/* Event Registration Page */}
          <Route path="/event-register" element={<EventRegisterPage />} />

          {/* Backward Compatibility / Alias Redirects to Lowercase Routes */}
          <Route path="/Home" element={<Navigate to="/" replace />} />
          <Route path="/home" element={<Navigate to="/" replace />} />
          <Route path="/About-us" element={<Navigate to="/about-us" replace />} />
          <Route path="/about" element={<Navigate to="/about-us" replace />} />
          <Route path="/Contact-us" element={<Navigate to="/contact-us" replace />} />
          <Route path="/contact" element={<Navigate to="/contact-us" replace />} />
          <Route path="/Menu" element={<Navigate to="/menu" replace />} />
          <Route path="/Menu-Details" element={<Navigate to="/menu-details" replace />} />
          <Route path="/Outdoor-Catering" element={<Navigate to="/outdoor-catering" replace />} />
          <Route path="/services/catering" element={<Navigate to="/outdoor-catering" replace />} />
          <Route path="/Barbequeen-Express" element={<Navigate to="/barbequeen-express" replace />} />
          <Route path="/services/express" element={<Navigate to="/barbequeen-express" replace />} />
          <Route path="/Events" element={<Navigate to="/events" replace />} />
          <Route path="/services/events" element={<Navigate to="/events" replace />} />
          <Route path="/Outlet-Gallery" element={<Navigate to="/outlet-gallery" replace />} />
          <Route path="/Fun-Activities" element={<Navigate to="/fun-activities" replace />} />
          <Route path="/services/fun-activities" element={<Navigate to="/fun-activities" replace />} />
          <Route path="/Awards-Achievements" element={<Navigate to="/awards-achievements" replace />} />
          <Route path="/services/awards" element={<Navigate to="/awards-achievements" replace />} />
          <Route path="/awards" element={<Navigate to="/awards-achievements" replace />} />
          <Route path="/Outlets" element={<Navigate to="/outlets" replace />} />
          <Route path="/Franchise" element={<Navigate to="/franchise" replace />} />
          <Route path="/Career" element={<Navigate to="/career" replace />} />
          <Route path="/Privacy-Policy" element={<Navigate to="/privacy-policy" replace />} />
          <Route path="/Terms-And-Conditions" element={<Navigate to="/terms-and-conditions" replace />} />
          <Route path="/Reservation" element={<Navigate to="/reservation" replace />} />
          <Route path="/Varnangal-Aayiram2.O" element={<Navigate to="/varnangal-aayiram2.o" replace />} />
          <Route path="/sitemap.xml" element={<Navigate to="/sitemap.xml" replace />} />

          {/* Specific Outlet routes matching web.php */}
          <Route path="/pudukkottai" element={<OutletsPage />} />
          <Route path="/pudukkottai/sipcot" element={<OutletsPage />} />
          <Route path="/erode/perunduarai-road" element={<OutletsPage />} />
          <Route path="/coimbatore/saibabacolony" element={<OutletsPage />} />
          <Route path="/salem" element={<OutletsPage />} />
          <Route path="/salem/cherry-road" element={<OutletsPage />} />
          <Route path="/salem/fairlands" element={<OutletsPage />} />
          <Route path="/salem/gugai" element={<OutletsPage />} />
          <Route path="/salem/hasthampatty" element={<OutletsPage />} />
          <Route path="/salem/five-roads" element={<OutletsPage />} />
          <Route path="/salem/seelanaickenpatti" element={<OutletsPage />} />
          <Route path="/salem/sona-college" element={<OutletsPage />} />
          <Route path="/salem/yercaud-main-road" element={<OutletsPage />} />

          {/* Dedicated SEO Landing Pages */}
          <Route path="/best-restaurant-in-salem" element={<BestRestaurantInSalemPage />} />
          <Route path="/best-restaurant-in-erode" element={<BestRestaurantInErodePage />} />
          <Route path="/best-restaurant-in-coimbatore" element={<BestRestaurantInCoimbatorePage />} />
          <Route path="/best-restaurant-in-krishnagiri" element={<BestRestaurantInKrishnagiriPage />} />
          <Route path="/best-restaurant-in-pudukkottai" element={<Navigate to="/blog/best-restaurant-in-pudukkottai" replace />} />
          <Route path="/best-restaurant-in-Pudukkottai" element={<Navigate to="/blog/best-restaurant-in-pudukkottai" replace />} />
          <Route path="/best-bbq-restaurant-in-pudukkottai" element={<BestBbqRestaurantInPudukkottaiPage />} />
          <Route path="/best-bbq-restaurant-pudukkottai" element={<BestBbqRestaurantInPudukkottaiPage />} />

          {/* Other SEO Landing Page Routes matching web.php */}
          <Route path="/best-mandi-in-krishnagiri" element={<BlogDetailPage />} />
          <Route path="/best-chicken-biryani-in-krishnagiri" element={<BlogDetailPage />} />
          <Route path="/best-biryani-in-krishnagiri" element={<BlogDetailPage />} />
          <Route path="/best-biryani-in-salem" element={<BlogDetailPage />} />
          <Route path="/best-barbecue-in-coimbatore" element={<BlogDetailPage />} />
          <Route path="/best-biryani-in-coimbatore" element={<Navigate to="/blog/best-biryani-in-coimbatore" replace />} />
          <Route path="/best-biryani-in-pudukkottai" element={<Navigate to="/blog/best-biryani-in-pudukkottai" replace />} />

          {/* Dynamic Menu routes */}
          <Route path="/menu/:slug/:id" element={<MenuDetailPage />} />
          <Route path="/outlet/:galleryslug/:id" element={<OutletGalleryPage />} />

          {/* Blog routes matching web.php */}
          <Route path="/blog/best-bbq-restaurant-pudukkottai" element={<BestBbqRestaurantInPudukkottaiPage />} />
          <Route path="/blog/best-bbq-restaurant-in-pudukkottai" element={<Navigate to="/blog/best-bbq-restaurant-pudukkottai" replace />} />
          <Route path="/blog/best-restaurant-in-pudukkottai" element={<BestRestaurantInPudukkottaiPage />} />
          <Route path="/blog/best-restaurant-in-Pudukkottai" element={<Navigate to="/blog/best-restaurant-in-pudukkottai" replace />} />
          <Route path="/blog/best-restaurant-in-coimabtore" element={<Navigate to="/blog/best-restaurant-in-coimbatore" replace />} />
          <Route path="/blog" element={<BlogListPage />} />
          <Route path="/blog/:slug" element={<BlogDetailPage />} />

          {/* SEO Landing Page / Fallback slug routes matching web.php */}
          <Route path="/:slug/:id" element={<MenuDetailPage />} />
          <Route path="/:slug" element={<BlogDetailPage />} />
        </Routes>
      </main>
      <Footer />
    </>
  );
};

export default AppRoutes;
